(() => {
  if (window.Shopify?.country !== 'DE' || String(window.Shopify?.locale || '').split('-')[0] !== 'de') return;
  const settings = document.getElementById('nera-language-de-labels');
  if (!settings) return;
  let labels;
  try { labels = JSON.parse(settings.textContent); } catch (_) { return; }

  // Only app interface labels are eligible. Product images and review content are untouched.
  const replaceText = (selector, original, replacement) => {
    if (!replacement) return;
    document.querySelectorAll(selector).forEach(element => {
      Array.from(element.childNodes).forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === original) {
          node.textContent = node.textContent.replace(original, replacement);
        }
      });
    });
  };
  const replaceAttribute = (selector, original, replacement) => {
    if (!replacement) return;
    document.querySelectorAll(selector).forEach(element => {
      if (element.getAttribute('aria-label') === original) element.setAttribute('aria-label', replacement);
    });
  };
  const updateLabels = () => {
    replaceText('.jdgm-carousel-title', 'Lassen Sie Kunden für uns sprechen', labels.reviewsTitle);
    replaceText('.jm-sort-filter > label, label.jdgm-visually-hidden', 'Sort reviews by', labels.reviewsSort);
    replaceAttribute('.jdgm-sort-dropdown', 'Sort reviews by', labels.reviewsSort);
    replaceAttribute('.jdgm-carousel__left-arrow', 'Previous reviews', labels.reviewsPrevious);
    replaceAttribute('.jdgm-carousel__right-arrow', 'Next reviews', labels.reviewsNext);
    replaceText('#track123_order_email', 'Email oder Telefonnummer', labels.trackingEmail);
    replaceText('.track123_input_container .track123_form_error', 'Email oder Telefon benötigt', labels.trackingEmailError);
  };
  const initialize = () => {
    updateLabels();
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(() => {
        pending = false;
        updateLabels();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
